import { render, staticRenderFns } from "./Spendplan.vue?vue&type=template&id=5a0d564c&"
import script from "./Spendplan.vue?vue&type=script&lang=js&"
export * from "./Spendplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports